'use client'

import { memo } from 'react'

interface RoomHeaderProps {
  roomTypeName: string
  roomSize?: string
  maxAdult: number
  maxChild: number
  bedType?: string
  onViewDetails: () => void
  t: (key: string) => string
}

function RoomHeader({
  roomTypeName,
  roomSize,
  maxAdult,
  maxChild,
  bedType,
  onViewDetails,
  t,
}: RoomHeaderProps) {
  return (
    <>
      <h2 className="line-clamp-2 font-lora text-base font-medium leading-6 text-secondary-950">
        {roomTypeName}
      </h2>
      <div className="flex items-center justify-items-start gap-1">
        {roomSize && (
          <>
            <div className="text-[12px] font-[350] leading-4 text-secondary-950">{roomSize} m²</div>
            <div className="text-[12px] font-[350] leading-4 text-[#ABAFB5]">•</div>
          </>
        )}
        <div className="text-[12px] font-[350] leading-4 text-secondary-950">
          {maxAdult} {t('booking.adults')}
        </div>
        <div className="text-[12px] font-[350] leading-4 text-[#ABAFB5]">•</div>
        <div className="text-[12px] font-[350] leading-4 text-secondary-950">
          {maxChild} {t('booking.children')}
        </div>
        {bedType && (
          <>
            <div className="text-[12px] font-[350] leading-4 text-[#ABAFB5]">•</div>
            <div className="text-[12px] font-[350] leading-4 text-secondary-950">{bedType}</div>
          </>
        )}
      </div>
      <div className="flex justify-start">
        <button
          onClick={onViewDetails}
          className="font-lexend text-xs font-light text-black underline hover:text-primary-600"
        >
          {t('roomType.viewDetails')}
        </button>
      </div>
    </>
  )
}

function arePropsEqual(prevProps: RoomHeaderProps, nextProps: RoomHeaderProps) {
  return (
    prevProps.roomTypeName === nextProps.roomTypeName &&
    prevProps.roomSize === nextProps.roomSize &&
    prevProps.maxAdult === nextProps.maxAdult &&
    prevProps.maxChild === nextProps.maxChild &&
    prevProps.bedType === nextProps.bedType
  )
}

export default memo(RoomHeader, arePropsEqual)
